import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { CanActivate, CanActivateChild, CanLoad, Router, UrlTree } from '@angular/router';
import { AccountService } from '@core/services/account.service';
import { map } from 'rxjs/operators';
import { ErrorCode } from '@core/components/error/error.component';
import { Observable } from 'rxjs';
import { StorageService } from '@core/services/storage/storage.service';
import { CountryName } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class MemberFirmGuard implements CanActivateChild, CanActivate, CanLoad {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private location: Location,
    private storage: StorageService
  ) {}

  public canActivateChild(): Observable<boolean | UrlTree> {
    return this.isAccessPermitted().pipe(
      map(
        isPermitted =>
          isPermitted ||
          this.router.createUrlTree(['/error/', ErrorCode.MemberFirm], { queryParams: { path: this.location.path() } })
      )
    );
  }

  public canLoad(): Observable<boolean> {
    return this.isAccessPermitted().pipe(
      map(
        isPermitted =>
          isPermitted ||
          this.router.navigate(['/error/', ErrorCode.MemberFirm], { queryParams: { path: this.location.path() } })
      )
    ) as Observable<boolean>;
  }

  public canActivate(): Observable<boolean | UrlTree> {
    return this.isAccessPermitted().pipe(
      map(
        isPermitted =>
          isPermitted ||
          this.router.createUrlTree(['/error/', ErrorCode.MemberFirm], { queryParams: { path: this.location.path() } })
      )
    );
  }

  private isAccessPermitted(): Observable<boolean> {
    return this.accountService.account$.pipe(
      map(
        account =>
          [CountryName.israel, CountryName.usa].includes(account.country) ||
          this.storage.accessGrantedForNonMemberFirmUser
      )
    );
  }
}
